import 'core-js/stable';
import 'regenerator-runtime/runtime';
import * as PIXI from 'pixi.js';
import { Game } from './framework/Game';
import { sceneMap } from './scenes/scenes';
import { ISgSdkSettings, ISgSdkHandler, TriggerAction } from "./sdk/types";
import { loadingUpdate, loadingComplete, start } from "js/sdk/sdkFunctions";
import { default as languages } from 'json/languages.json';
import { ScenesName } from "js/scenes/scenes";
import initLeaderboad from "@softgames/firebase-leaderboard";
import firebaseConfig from "../firebaseConfig.json";

let locale: string = 'en';
declare const sgSdk: any;
let sgSettings: any;
let sdkHandler: any;
declare global {
  interface Window {
    game: Game;
    PIXI: typeof PIXI;
    sgGameConfig: ISgSdkSettings["config"];
    sdkHandler: ISgSdkHandler; 
  }
}

export const appWidth = 730;
export const appHeight = 1085;

const game = new Game(
  {
    transparent: false,
    backgroundColor: 0xffffff,
    width: window.innerWidth,
    height: window.innerHeight,
  },
  {
    scenes: sceneMap,
    resizeHandler: () => {
      const mw: number = appHeight / window.innerHeight;
      const mh: number = appWidth / window.innerWidth;
      const scale: number = Math.max(mw, mh);
      return [
        window.innerWidth * scale,
        window.innerHeight * scale,
      ];
    },
  }
);

// (async function() {
//   // @ts-ignore
//   window.onWrapperReady = async () => {
//     const { config, handler } = await game.initialize();
  
//     window.sgGameConfig = config;
//     window.sdkHandler = handler;
  
//     await game.load();
//     loadingComplete();
//   }
// })();

// @ts-ignore
window.onWrapperReady = () => {
  if (sgSdk.deviceDectorFunctions().isMobileOrTab()) {
    var setOrientation = () => {
      if (window.orientation == 0) {
        unpauseGame();
        document.getElementById("orientation")!.style.display = "none";
      } else {
        pauseGame();
        document.getElementById("orientation")!.style.display = "block";
      }
    }

    window.addEventListener("orientationchange", () => {
      setOrientation();
    });
    setOrientation();
    window.setTimeout(() => {
      setOrientation();
    }, 1000)
  }
  sgSdk.initialize(
    ['basic', 'scoreGame'],
    {
      id: process.env.GAMEID,
      build: process.env.VERSION,
      supportedLanguages: Object.keys(languages),
      runGame: () => {
        game.scenes.startScene(ScenesName.Main);
        sgSdk.setAdClosedCallback(() => { window.focus() });
      },
      startOver: () => { },
      freezeGame: () => {
        pauseGame();
      },
      unfreezeGame: () => {
        unpauseGame();
      },
    },
    async (error, settings, handler) => {
      sgSettings = settings;
      sdkHandler = handler;

      const { config } = settings;

      game.setLocale(config.env.locale);

      game.leaderboard = await initLeaderboad({
        firebaseConfig,
        publisherId : '10001',
        playersToShow : 50
      });

      window.sgGameConfig = config;
      window.sdkHandler = handler;
    
      await game.load();
      loadingComplete();
    },
  );
}

window.game = game;
window.PIXI = PIXI;

export {
  game,
  sdkHandler,
  sgSettings
};

export function pauseGame() {
  window.game.gamePause = true;
  window.game.sounds.music.stop();
}

export function unpauseGame() {
  window.game.gamePause = false;
  window.game.sounds.music.stop();
  window.game.sounds.music.play();
}